<template>
  <draggable v-model="localQuestions" tag="tbody" @end="onDragEnd">
    <tr v-for="(item, index) in localQuestions" :key="index">
      <template v-if="item !== undefined">
        <td><fluent-icon icon="drag" /></td>
        <td>
          <input
            v-model.trim="item.title"
            type="text"
            class="m-0 min-w-[150px]"
          />
        </td>
        <td>
          <select
            v-model="item.type"
            class="mb-0 min-w-[160px]"
            @change="handleUpdatedQuestionType(item)"
          >
            <option
              v-for="type in questionTypes"
              :key="type.key"
              :value="type.key"
            >
              {{ type.value }}
            </option>
          </select>
        </td>
        <td class="text-center align-middle">
          <input
            v-if="item.type !== 'checkbox'"
            v-model="item.mandatory"
            class="checkbox mb-0"
            type="checkbox"
          />
        </td>
        <td class="w-2/5">
          <multiselect
            v-if="
              item.type === 'dropdown_list' ||
              item.type === 'combo_selection' ||
              item.type === 'multiple_choice_markup' ||
              item.type === 'single_choice_markup'
            "
            v-model.trim="item.options"
            :options="[]"
            :multiple="true"
            :taggable="true"
            :placeholder="
              $t(
                'CSAT_MGMT.QUESTION_BUILDER.SETUP_QUESTIONS.OPTION_INPUT_PLACEHOLDER'
              )
            "
            class="!m-0 w-full"
            label="title"
            track-by="title"
            @tag="addTag(item, $event)"
          />
        </td>
        <td>
          <woot-button
            v-tooltip.top="$t('CSAT_MGMT.FORM.DELETE')"
            variant="smooth"
            color-scheme="alert"
            size="tiny"
            icon="dismiss-circle"
            class-names="grey-btn"
            @click="handleDeleteQuestion(item)"
          />
        </td>
      </template>
    </tr>
    <tr v-if="localQuestions.length === 0">
      <td colspan="7" class="text-center">
        {{ $t('CSAT_MGMT.QUESTION_BUILDER.SETUP_QUESTIONS.NO_QUESTIONS') }}
      </td>
    </tr>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable';
import { getQuestionTypes } from '../constants';
export default {
  components: { draggable },
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      questionTypes: getQuestionTypes.bind(this)(),
      localQuestions: [...this.questions],
      options: [],
      selected: [],
      displayOptions: false,
    };
  },
  watch: {
    questions() {
      this.localQuestions = this.questions;
    },
  },
  methods: {
    handleUpdatedQuestions(item, type) {
      const result = this.localQuestions.map(question => {
        if (question === item) {
          return { ...question, [type]: !question[type] };
        }
        return question;
      });
      this.$emit('update', result);
    },
    handleDeleteQuestion(item) {
      const result = this.localQuestions.filter(question => question !== item);
      this.$emit('update', result);
    },
    onDragEnd() {
      this.$emit('update', this.localQuestions);
    },
    addTag(item, newTag) {
      const tag = {
        title: newTag,
        id:
          'op_' +
          Date.now().toString(36) +
          Math.random().toString(36).substr(2),
      };
      const result = this.localQuestions.map(question => {
        if (question === item) {
          return { ...question, options: [...(question.options || []), tag] };
        }
        return question;
      });
      this.$emit('update', result);
    },
    handleUpdatedQuestionType(item) {
      item.options = [];
      this.$emit('update', this.localQuestions);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .multiselect__content-wrapper {
    display: none !important;
  }
}
</style>
